import styles from './FJAIVideoGeneratorRight.module.less';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer.jsx';
import FJCreationPanelContainer from '../../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer.jsx';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer.jsx';
import FJAIVideoGeneratorProgress from './FJAIVideoGeneratorProgress.jsx';
import FJAppConstant from '../../../../constants/FJAppConstant.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJSortIcon from '../../../../assets/svg/sort.svg?react';
import FJCheckIcon from '../../../../assets/svg/check.svg?react';
import FJArrowIcon from '../../../../assets/svg/button-pull-down.svg?react';
import { useRef } from 'react';
import FJDragBox from '../../../../common/components/FJDragBox/FJDragBox.jsx';
import PropTypes from 'prop-types';

const FJAIVideoGeneratorRight = props => {
    const {
        currentGenerateStatus,
        imgUrl,
        getCredit,
        headerTabIndex,
        generatingVideoNum = 0,
        isShowGeneratingVideoNum,
        sortType,
        setSortType,
        showHistoryNum,
        setIsDraggingFile,
        uploadFile,
        reGenerate,
        jumpHistory,
        creditNumber,
    } = props;

    const isShowPresetImageBox = currentGenerateStatus === FJAppConstant.IDLE;

    const filterList = useRef(['all-videos', 'text-to-video', 'image-to-video']);
    const dropRef = useRef(null);

    const _renderBtnGroup = () => {
        if (generatingVideoNum > 0 && isShowGeneratingVideoNum) {
            return (
                <div className={styles.num}>
                    {generatingVideoNum === 1
                        ? FJLocalStore._('generating-video').replace('xxx', generatingVideoNum)
                        : FJLocalStore._('generating-videos').replace('xxx', generatingVideoNum)}
                </div>
            );
        }
        return null;
    };
    const _renderTrigger = config => {
        return (
            <div className={styles.sort_btn} ref={config.ref} onClick={config.onClick}>
                <div className={styles.sort_content}>
                    <FJSortIcon className={styles.left_icon} />
                    {FJLocalStore._(sortType)}
                </div>
                <FJArrowIcon className={styles.right_icon} />
            </div>
        );
    };

    const _renderOverlay = config => {
        return (
            <div className={styles.overlay_box} ref={config.ref}>
                <ul>
                    {filterList.current.map(item => (
                        <li
                            className={sortType === item ? styles.active : ''}
                            onClick={() => {
                                dropRef.current.hide();
                                setSortType(item);
                            }}
                            key={item}
                        >
                            {FJLocalStore._(item)}
                            <FJCheckIcon />
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    const renderHeader = () => {
        return (
            <div className={styles.history_header}>
                <div className={styles.history_num}>
                    {FJLocalStore._(showHistoryNum === 1 ? '_result' : '_results').replace('xxx', showHistoryNum)}
                </div>
                <FJDropdownNew
                    renderTrigger={_renderTrigger}
                    renderOverlay={_renderOverlay}
                    placement='bottomRight'
                    offsetTop={4}
                    useAnchorBody
                    ref={dropRef}
                />
            </div>
        );
    };

    return (
        <FJDragBox
            setIsDragging={setIsDraggingFile}
            uploadFile={uploadFile}
            className={styles.app_right}
            style={{ padding: currentGenerateStatus !== FJAppConstant.IDLE || headerTabIndex === 1 ? '0 21px' : 0 }}
        >
            <FJDisplayHeaderContainer rightChildren={_renderBtnGroup()} className={styles.header} />
            {(currentGenerateStatus === FJAppConstant.IDLE || currentGenerateStatus === FJAppConstant.SUCCESS) && (
                <FJCreationPanelContainer
                    activeHeaderTabIndex={0}
                    hideCompare={true}
                    isShowPresetImageBox={isShowPresetImageBox}
                />
            )}
            {(currentGenerateStatus === FJAppConstant.RUNNING || currentGenerateStatus === FJAppConstant.ERROR) &&
                headerTabIndex === 0 && (
                    <FJAIVideoGeneratorProgress
                        imgUrl={imgUrl}
                        getCredit={getCredit}
                        status={currentGenerateStatus}
                        reGenerate={reGenerate}
                        jumpHistory={jumpHistory}
                        creditNumber={creditNumber}
                    />
                )}
            <FJHistoryPanelContainer activeHeaderTabIndex={1} headerChildren={renderHeader()} />
        </FJDragBox>
    );
};

FJAIVideoGeneratorRight.propTypes = {
    currentGenerateStatus: PropTypes.string,
    imgUrl: PropTypes.string,
    getCredit: PropTypes.func,
    headerTabIndex: PropTypes.number,
    generatingVideoNum: PropTypes.number,
    isShowGeneratingVideoNum: PropTypes.bool,
    sortType: PropTypes.string,
    setSortType: PropTypes.func,
    showHistoryNum: PropTypes.number,
};

export default FJAIVideoGeneratorRight;
